import { SwapOutlined } from "@ant-design/icons";

function PredecessorSuccessorTag(props: { title: string }) {
  const { title } = props;
  return (
    <div className="flex text-xs bg-ciq-gray-500 text-black text-opacity-90 italic rounded-[4px] p-1 px-2 space-x-1 items-center">
      <SwapOutlined className="text-ciq-gray-550" />
      <span>{title}</span>
    </div>
  );
}
export default PredecessorSuccessorTag;
